import HotelStatusIcon from 'components/HotelStatusIcon'
import moment from 'moment'
import { useState } from 'react'
import { Link } from 'react-router-dom'

import { Cell, Row } from '../../../../components/ReusableComponents/Table'
import { formatPrice } from '../../../../utils/common'
import HotelIdCell from '../../Common/HotelIdCell'
import HotelNameCell from '../../Common/HotelNameCell'
import CustomTooltip from '../Tooltip'
import styles from './PMSBErow.module.scss'
import { ReactComponent as StartIcon } from './start.svg'

const statusStyles = {
  Paid: 'good',
  ReviewCompleted: 'bad',
  ReviewPending: 'bad',
  PaymentOverdue: 'bad',
  PaymentFailed: 'bad',
  PaymentPending: 'badish',
  MonthInProgress: 'none',
  PaidPartially: 'badish'
}

const statusNames = {
  Paid: 'Paid',
  PaidPartially: 'Partially paid',
  PaymentPending: 'Payment pending',
  ReviewPending: 'NOT SENT',
  ReviewCompleted: 'NOT SENT',
  PaymentFailed: 'Payment failed',
  PaymentOverdue: 'Payment overdue',
  MonthInProgress: 'Month in progress',
  MonthSkipped: 'Month skipped'
}

const statusColors = {
  good: '#66BB6A',
  none: '#6E8282',
  bad: '#FF4545',
  badish: 'purple',
  amountInfoBadish: '#ED8D3D'
}

const DoubleCell = ({
  primary,
  secondary,
  highlighted,
  isServiceStartMonth,
  reconciliationPending,
  bookingCountToCharge,
  totalBookingValueToCharge,
  totalAmountDue,
  deliveredOn,
  totalBookingValueNotCharged,
  bookingCountNotCharged,
  ...props
}) => {
  const [isHovering, setHovering] = useState()

  const tooltipProps = {
    bookingCountToCharge,
    totalBookingValueToCharge,
    totalAmountDue,
    deliveredOn,
    totalBookingValueNotCharged,
    bookingCountNotCharged
  }

  return (
    <Cell className={styles.doubleCell} {...props}>
      {secondary ? (
        <div
          onMouseOver={() => setHovering(true)}
          onMouseLeave={() => setHovering(false)}
        >
          <div
            className={styles.doubleCellPrimary}
            style={{ opacity: highlighted ? 1 : 0.2 }}
          >
            {isServiceStartMonth && <StartIcon />} {formatPrice(primary)}{' '}
            {reconciliationPending && reconciliationPending > 0 ? (
              <span className={styles.pill}>{reconciliationPending}</span>
            ) : null}
          </div>
          <div
            className={styles.doubleCellSecondary}
            style={{
              color: statusColors[statusStyles[secondary]],
              fontWeight: statusStyles[secondary] === 'bad' ? 500 : 'normal',
              opacity: highlighted ? 1 : 0.3
            }}
          >
            {statusNames[secondary]}
          </div>
          <CustomTooltip {...tooltipProps} isVisible={isHovering} />
        </div>
      ) : (
        <span className={styles.dash}>-</span>
      )}
    </Cell>
  )
}

const GoToBillingAndPayments = ({ subsidiaryId }) => {
  return (
    <Link to={`/s/${subsidiaryId}/billing`}>
      <button>Go to Billing &amp; Payments →</button>
    </Link>
  )
}

function isCellHighlighted(highlightPaymentPending, highlightNotSent, status) {
  if (!highlightNotSent && !highlightPaymentPending) {
    return true
  }

  if (highlightPaymentPending && status === 'PaymentPending') {
    return true
  }
  if (highlightNotSent && (status === 'ReviewPending' || status === 'ReviewCompleted')) {
    return true
  }

  return false
}

const InvoicesRow = ({
  displayId,
  brand,
  shortName,
  months,
  subsidiaryId,
  items,
  serviceStartDate,
  highlightPaymentPending,
  highlightNotSent,
  index,
  subsidiaryStatus,
  rowStatus,
  statusExplanation,
  csmUserFullName
}) => (
  <div
    className={`${styles.rowHolder} ${rowStatus ? styles[rowStatus] : ''}`}
    title={statusExplanation}
  >
    <div className={styles.index}>{index}</div>
    <div className={styles.statusIcon}>
      <HotelStatusIcon status={subsidiaryStatus} />
    </div>
    <Row>
      <HotelIdCell displayId={displayId} />
      <HotelNameCell
        brand={brand}
        name={shortName}
        navigationControl={<GoToBillingAndPayments subsidiaryId={subsidiaryId} />}
      />
      <Cell className={styles.textCell}>
        <span title={csmUserFullName}>
          {csmUserFullName
            ?.split(' ')
            .map(str => str[0])
            .join('.')}
        </span>
      </Cell>
      {months.map(m => (
        <DoubleCell
          highlighted={isCellHighlighted(
            highlightPaymentPending,
            highlightNotSent,
            items?.[m]?.status
          )}
          reconciliationPending={items?.[m]?.reconciliationPending}
          isServiceStartMonth={moment(m).isSame(moment(serviceStartDate), 'month')}
          key={displayId + m}
          primary={items?.[m]?.totalAmountDue}
          secondary={items?.[m]?.status}
          bookingCountToCharge={items?.[m]?.bookingCountToCharge}
          totalBookingValueToCharge={items?.[m]?.totalBookingValueToCharge}
          totalAmountDue={items?.[m]?.totalAmountDue}
          deliveredOn={items?.[m]?.deliveredOn}
          totalBookingValueNotCharged={items?.[m]?.totalBookingValueNotCharged}
          bookingCountNotCharged={items?.[m]?.bookingCountNotCharged}
        />
      ))}
    </Row>
  </div>
)

export default InvoicesRow
